import React, { createContext, forwardRef } from 'react';
import PropTypes from 'prop-types';

const LanguageContext = createContext();
const LanguageProvider = LanguageContext.Provider;

/**
 * LanguageConsumer
 *
 * @param   {object} children
 * @return  {ReactNode}
 */
const LanguageConsumer = forwardRef(({children, props}, ref) => {
    const Components = children;
    return (
        <LanguageContext.Consumer>
            {(context) => {
                if (context === undefined) {
                    throw new Error('LanguageContext must be used within a LanguageProvider');
                }
                return (<Components {...context} {...props} ref={ref} />);
            }}
        </LanguageContext.Consumer>
    );
});
LanguageConsumer.displayName = 'LanguageConsumer';
LanguageConsumer.propTypes = {
    props: PropTypes.object,
};

export {
    LanguageConsumer,
    LanguageProvider,
};
